import CallSplitIcon from '@mui/icons-material/CallSplit';
import { ListItemIcon, MenuItem, Typography } from '@mui/material';
import React from 'react';

interface IAddConditionButtonProps {
	onClick: (e: React.MouseEvent) => void;
	width: number;
}

const AddConditionButton = ({ onClick, width }: IAddConditionButtonProps) => (
	<MenuItem onClick={onClick} data-testid="add-condition-task" sx={{ width }}>
		<ListItemIcon>
			<CallSplitIcon />
		</ListItemIcon>
		<Typography variant="inherit">
			{intl.tr('flows.builder.add.item.condition')}
		</Typography>
	</MenuItem>
);

AddConditionButton.defaultProps = {};

export default AddConditionButton;
